// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__dQYvV","horizontalLine":"IconPlus_horizontalLine__Qw8n0","verticalLine":"IconPlus_verticalLine__cHdE7","lineVerticalOpen":"IconPlus_lineVerticalOpen__nw8bW"};